import { render, staticRenderFns } from "./BuySection.vue?vue&type=template&id=3b3f90f3&scoped=true"
import script from "./BuySection.vue?vue&type=script&lang=js"
export * from "./BuySection.vue?vue&type=script&lang=js"
import style0 from "./BuySection.vue?vue&type=style&index=0&id=3b3f90f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3f90f3",
  null
  
)

export default component.exports